import React from "react";
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";
import { ReactComponent as LogoSvg } from '../../../assets/images/logo.svg';
import { ReactComponent as LinkedInIconSvg } from '../../../assets/images/linkedInIcon.svg';
import { ReactComponent as LocationDotIconSvg } from '../../../assets/images/locationDotIcon.svg';
import { ReactComponent as AtIconSvg } from '../../../assets/images/atIcon.svg';
import { ReactComponent as PhoneIconSvg } from '../../../assets/images/phoneIcon.svg';
import footerArcImg from '../../../assets/images/footerArc.png';

import './style.scss'; 

export default function Footer () {
    return (
        <Container fluid className="footer position-relative">
            <img src={footerArcImg} className="footer-arc" alt="footer arc"/>
            <Row>
                <Col xs={12} md={3}>
                    <LogoSvg className="logo"/>
                    <div className="copyright">
                        <p>Devsmore.com-All rights reserved.</p>
                        <p>{ new Date().getFullYear() } DevsMore&copy;</p>
                    </div>
                </Col>
                <Col xs={12} md={3} className="footer-col">
                    <h5>Company</h5>
                    <Link to="/about-us">About us</Link>
                    <Link to="/services">Services</Link>
                    <Link to="/contacts">Contact Us</Link>
                </Col>
                <Col xs={12} md={3}  className="footer-col border-line-left">
                    <h5>Contact us</h5>
                    <div className="footer-icon-text">
                        <LocationDotIconSvg />
                        <p>Sofia, Bulgaria</p>
                    </div>
                    <div className="footer-icon-text">
                        <AtIconSvg />
                        <p className="text-decoration-underline">info@devsmore.com</p>
                    </div>
                    <div className="footer-icon-text">
                        <PhoneIconSvg />
                        <p className="text-decoration-underline">+359 888 531236</p>
                    </div>
                </Col>
                <Col xs={12} md={3} className="footer-col border-line-left">
                    <h5>Follow us</h5>
                    <Link target="_blank" to="https://www.linkedin.com/company/devsmore/about/">
                        <div className="footer-icon-text">
                            <LinkedInIconSvg />
                            <p>LinkedIn</p>
                        </div>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
}
